/**
 * RequireAppAdmin — app_admin only. Thin wrapper over RequireRole.
 */
import { ReactNode } from "react";
import { RequireRole } from "./RequireRole";

export function RequireAppAdmin({ children }: { children: ReactNode }) {
  return (
    <RequireRole allowedRoles={["app_admin"]} deniedRedirect="/app" deniedMessage="Admin access required">
      {children}
    </RequireRole>
  );
}

export default RequireAppAdmin;
